export interface IGetCardInfo {
  bin: string;
  last4?: string;
}

const getCardInfo = (cardNumber: string): IGetCardInfo => {
  const bin = cardNumber.slice(0, 6);
  const last4 = cardNumber.slice(-4);

  return {
    bin,
    last4,
  };
};

export default getCardInfo;
